// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    agentsTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Agents Title",
        translatable: true
    },
    aiProductsTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Ai Products Title",
        translatable: true
    },
    buttonText: {
        type: FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    headingBlack1: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black 1",
        translatable: true
    },
    headingBlack2: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black 2",
        translatable: true
    },
    headingGradient: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Gradient",
        translatable: true
    },
    sidekickTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Sidekick Title",
        translatable: true
    },
    vibeTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Title",
        translatable: true
    },
    workflowsTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Workflows Title",
        translatable: true
    },
    agentsImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Agents Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    agentsLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Agents Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    aiProductsImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Ai Products Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    aiProductsLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Ai Products Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    sidekickImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Sidekick Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    sidekickLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Sidekick Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    vibeImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Vibe Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    vibeLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Vibe Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    workflowsImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Workflows Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    workflowsLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Workflows Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    headingBlack1Visibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Heading Black 1 Visibility",
        translatable: false
    },
    headingBlack2Visibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Heading Black 2 Visibility",
        translatable: false
    },
    hideComponent: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Hide Component",
        translatable: false
    }
};
